import AgreementPage from "../../pages/AgreementPage/AgreementPage";

export enum PATHS {
    SHOP = "/",
    SHOPLITE = "/lite",
    SHOPTRIO = "/trio",
    DEPOSIT = "/deposit",
    AGREEMENT = "/agreement",
    PRIVACY = "/privacy",
    CUSTOM = "/custom",
    LOGOUT = "/logout",
    LOGIN = "/auth/steam/",
    PROFILE = "/profile",
    ABOUT = "/about",
    SETTINGS = "/settings",
    MAP = "/map",
    STATS = "/stats",
    CASE = "/case",
    GIVEAWAYS = "/giveaways",
    ADMIN = "/admin"
}

export enum URL {
    FRONT = "http://localhost:5173/",
    BACKEND = "http://localhost:5000/",
}